export default __webpack_public_path__ + "static/media/contactThanks_woman-standing.82ee92b9.svg";